import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'servicesToStr'
})
export class ServicesToStrPipe implements PipeTransform {

  transform(value: any[]): string {
    if (!value || value.length === 0) {
      return '';
    }

    let result = '';
    const lastIndex = value.length - 1;

    value.forEach((item, index) => {
      result += item.serviceName + ' x ' + item.qty;
      if (index !== lastIndex) {
        result += ', ';
      }
    });
    
    return result;
  }
}
